import React from 'react';
import { Hero } from './components/Hero';
import { HeroTestimonials } from './components/HeroTestimonials';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { IncludesSection } from './components/IncludesSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencyBlock } from './components/UrgencyBlock';
import { PricingSection } from './components/PricingSection';
import { UpsellTable } from './components/UpsellTable';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { LiveToast } from './components/LiveToast';
export function App() {
  return <div className="w-full overflow-x-hidden bg-ink-900 font-sans text-white" data-id="element-0" data-mp="23t8heerpojdg">
      <Hero data-id="element-1" data-mp="3ijfx0558q6h9" />
      <main data-id="element-2" data-mp="3ijpe138b53at">
        <HeroTestimonials data-id="element-3" data-mp="3ii4su47vuwpm" />
        <ProblemSection data-id="element-4" data-mp="3ml14tc2x3ukl" />
        <VolumesSection data-id="element-5" data-mp="3mkhnnxl3da7m" />
        <IncludesSection data-id="element-6" data-mp="3mjq2zht18ww4" />
        <BonusesSection data-id="element-7" data-mp="3rc9du70c5dx8" />
        <UrgencyBlock data-id="element-8" data-mp="3rbrcwx2qabiz" />
        <PricingSection id="ofertas" data-id="element-9" data-mp="3rdkgg3i1ofmr" />
        <UpsellTable data-id="element-10" data-mp="3relvej26lm9r" />
        <TestimonialsSection data-id="element-11" data-mp="5opiv1o0k3w" />
        <GuaranteeSection data-id="element-12" data-mp="4n4bxqxqh8g" />
        <FaqSection data-id="element-13" data-mp="56qxrrj5tst" />
        <CostSection data-id="element-14" data-mp="2zl3alhpbj03q" />
        <FinalCta data-id="element-15" data-mp="2zllcouynw8jk" />
      </main>
      <Footer data-id="element-16" data-mp="2zmem63p09c5e" />
      <LiveToast data-id="element-17" data-mp="2zmwhmy3ufmc9" />
    </div>;
}